<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-06-08 15:18:13
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      title="详情"
      :visible.sync="visible"
      width="50%"
      @close="close"
      ><el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="订单号">
          <el-input v-model="form.orderNo" readonly></el-input>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-input v-model="form.goodType" readonly></el-input>
        </el-form-item>
        <el-form-item label="预约时间">
          <el-input v-model="form.appointmentTimeEnd" readonly></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="form.userName" readonly></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input v-model="form.phone" readonly></el-input>
        </el-form-item>
        <el-form-item label="用户地址">
          <el-input v-model="form.detailAddress" readonly></el-input>
        </el-form-item>
        <el-form-item label="回收员">
          <el-input v-model="form.rebycleUserName" readonly></el-input>
        </el-form-item>
        <el-form-item label="实际重量">
          <el-input v-model="form.actualWeight" readonly></el-input>
        </el-form-item>
        <el-form-item label="回收金额">
          <el-input v-model="form.totalPrice" readonly></el-input>
        </el-form-item>
        <el-form-item label="签收时间">
          <el-input v-model="form.signInTime" readonly></el-input>
        </el-form-item>
        <el-form-item label="回收照片">
          <template v-if="form.photoImgUrl">
            <el-image
              v-for="(item, i) in form.photoImgUrl"
              style="width: 100px; height: 50px; margin-right: 10px"
              :src="item"
              :preview-src-list="[item]"
              :key="i"
            >
              <div slot="error" class="image-slot" style="width: 100px; height: 50px">
                <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
              </div>
            </el-image>
          </template>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";

export default {
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      form: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    close() {
      this.visible = false;
    },
    edit(val) {
      console.log(val);
      this.visible = true;
      httpAction(
        "/traceabilityCode/read/" + val.traceabilityCode,
        {},
        "get"
      ).then((res) => {
        console.log("🚀 ~ httpAction ~ res:", res);
        this.form = res.data
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrapper {
}
.formDiv {
  margin-left: 40px;
  margin-bottom: 22px;
  span {
    width: 80px;
    line-height: 36px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    font-weight: 700;
    color: #606266;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    cursor: default;
  }
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
.show /deep/ .el-upload--picture-card {
  display: block;
}
</style>
